namespace GeniuzPOS.QRreport {
    export enum stockFg {
        sFg1 = 0,
        sFg2 = 1
    }
    Serenity.Decorators.registerEnumType(stockFg, 'GeniuzPOS.QRreport.stockFg');
}
